import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import BackToButton from "../../../../shared/backToButton/BackToButton";
import styles from "./AccessoriesPricingWrapper.module.scss";
import SubNav from "../../../../shared/subnav/SubNav";
import BrandSettingsEU from "./brandSettings/BrandSettingsEU";
import AccessoriesSettingsEU from "./accessoriesSettings/AccessoriesSettingsEU";
import UpperCaseText from "../../../../utils/UpperCaseText";
import { MarketGroups } from "../../../../shared/marketGroups/MarketGroups";

class AccessoriesPricingWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTab: 0,
      enableTabs: false,
      showWarning: false,
      currencySymbol:
        this.props.localizedInfo && this.props.localizedInfo.defaultCurrency
          ? this.props.localizedInfo.defaultCurrency.symbol
          : this.props.t("CurrentPricing.na"),
    };
    this.showMarketDropDown =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "orderSearchMarketDropDown:view"
      );
  }

  onMarketChange = (event) => {
    const market = event.target.value;

    this.setState({
      currentTab: 0,
      currencySymbol: this.getCurrencySymbol(),
    });

    this.props.updateCurrentMarket(market);
  };

  handleTabChange = (event, currentTab) => {
    if (this.state.enableTabs) {
      this.setState({ currentTab });
    } else {
      this.setState({ showWarning: currentTab === 1 });
    }
  };

  getCurrencySymbol() {
    if (this.props.localizedInfo && this.props.localizedInfo.defaultCurrency) {
      return this.props.localizedInfo.defaultCurrency.symbol;
    }
    return "";
  }

  constructTabs() {
    return [
      {
        menuName: this.props.t("AccessoriesPricing.brandSettingsTab"),
        enabled: true,
        id: "brandSettings",
      },
      {
        menuName: this.props.t("AccessoriesPricing.accessoriesTab"),
        enabled: true,
        disabledStyle: !this.state.enableTabs,
        id: "accessories",
      },
    ];
  }

  enableOtherTabs = (value) => {
    this.setState({ enableTabs: value, showWarning: false });
  };

  closeWarning = () => {
    this.setState({ showWarning: false });
  };

  getSubNav = () => {
    return (
      <div className={styles.left}>
        <SubNav
          {...this.props}
          title={this.props.t("AccessoriesPricing.header")}
          selectedTab={this.state.currentTab}
          action={this.handleTabChange}
          tabs={this.constructTabs()}
          showCustomMarketDropdown={this.showMarketDropDown}
          listOfMarkets={MarketGroups(this.props.user.market)}
          updateMarket={this.onMarketChange}
        />
      </div>
    );
  };

  render() {
    return (
      <div className="pageWrapper">
        <BackToButton
          backToUrl="/pricing"
          display={this.props.t("PricingWrapper.backToPricing")}
        />
        {this.getSubNav()}
        {this.state.showWarning && (
          <div className={styles.dialogTitle}>
            <span className={styles.warning} />
            <div>
              {UpperCaseText(this.props.user.userType) === "NSC"
                ? this.props.t("AccessoriesPricing.warningMessageNsc")
                : this.props.t("AccessoriesPricing.warningMessage")}
            </div>
            <div
              className={styles.delete}
              onClick={() => {
                this.closeWarning();
              }}
            />
          </div>
        )}
        {this.state.currentTab === 0 ? (
          <BrandSettingsEU
            handleTabChange={this.handleTabChange}
            enableOtherTabs={this.enableOtherTabs}
            currencySymbol={this.state.currencySymbol}
            {...this.props}
          />
        ) : (
          this.state.currentTab === 1 && (
            <AccessoriesSettingsEU
              {...this.props}
              handleTabChange={this.handleTabChange}
              enableOtherTabs={this.enableOtherTabs}
              currencySymbol={this.state.currencySymbol}
            />
          )
        )}
      </div>
    );
  }
}

export default withTranslation("emp")(AccessoriesPricingWrapper);
